import { DeliveryBlockResource } from '@bringg/types';
import { getDaysBetweenDates } from '@bringg-frontend/utils';

import {
	ResourceWithBlockData,
	SelectedDriversAndVehiclesFromExistingRoutes,
	SelectedResourceInTeam,
	SelectedResources
} from './types';

export const CUSTOM_RESOURCE_HIGHEST_ID = -2;
const useResourceCheckbox = () => {
	const createCheckboxDataByResources = (
		resourcesList: ResourceWithBlockData[],
		selectedResources: SelectedResources,
		isOptimizeNewAndSaveExisting: boolean,
		selectedDriversAndVehiclesFromExistingRoutes
	) => {
		resourcesList.forEach(resource => {
			const resourceDates = getDaysBetweenDates(resource.startTime, resource.endTime, null);

			for (const date of Object.keys(resourceDates)) {
				if (!selectedResources[date]) {
					selectedResources[date] = { selectAllInDate: true, checkboxesByTeam: {} };
				}
				const selectedResourcesByTeamAndDate = createResourceCheckboxDataObject({
					isOptimizeNewAndSaveExisting,
					resource,
					selectedDriversAndVehiclesFromExistingRoutes,
					selectedResourcesInTeamByDate: selectedResources[date].checkboxesByTeam[resource.teamId],
					deliveryBlockStartOfDay: date
				});
				if (!selectedResources[date].checkboxesByTeam[resource.teamId]) {
					selectedResources[date].checkboxesByTeam[resource.teamId] = {} as SelectedResourceInTeam;
				}
				selectedResources[date].checkboxesByTeam[resource.teamId] = selectedResourcesByTeamAndDate;
				if (!selectedResourcesByTeamAndDate.selectAllInTeam) {
					selectedResources[date].selectAllInDate = false;
				}
			}
		});

		return selectedResources;
	};

	const isResourceSelectedOnPreviousOptimization = (
		isOptimizeNewAndSaveExisting,
		resource,
		selectedDriversAndVehiclesFromExistingRoutes,
		deliveryBlockStartOfDay
	): boolean => {
		return (
			isOptimizeNewAndSaveExisting &&
			(selectedDriversAndVehiclesFromExistingRoutes.users[deliveryBlockStartOfDay]?.[resource.user_id] ||
				selectedDriversAndVehiclesFromExistingRoutes.vehicles[deliveryBlockStartOfDay]?.[resource.vehicle_id])
		);
	};

	const createResourceCheckboxDataObject = ({
		isOptimizeNewAndSaveExisting,
		resource,
		selectedDriversAndVehiclesFromExistingRoutes,
		selectedResourcesInTeamByDate,
		deliveryBlockStartOfDay
	}: {
		isOptimizeNewAndSaveExisting: boolean;
		resource: DeliveryBlockResource;
		selectedDriversAndVehiclesFromExistingRoutes: SelectedDriversAndVehiclesFromExistingRoutes;
		selectedResourcesInTeamByDate?: SelectedResourceInTeam;
		deliveryBlockStartOfDay: string;
	}): SelectedResourceInTeam => {
		const isResourceSelected = isResourceSelectedOnPreviousOptimization(
			isOptimizeNewAndSaveExisting,
			resource,
			selectedDriversAndVehiclesFromExistingRoutes,
			deliveryBlockStartOfDay
		);
		if (selectedResourcesInTeamByDate) {
			const selectedResources = selectedResourcesInTeamByDate;
			if (isOptimizeNewAndSaveExisting) {
				selectedResources.selectedIds[resource.id] = {
					isChecked: !!isResourceSelected,
					disabled: !!isResourceSelected || resource.id <= CUSTOM_RESOURCE_HIGHEST_ID
				};
				if (!isResourceSelected) {
					selectedResources.selectAllInTeam = false;
				}
			} else {
				selectedResources.selectedIds[resource.id] = {
					isChecked: true,
					disabled: resource.id <= CUSTOM_RESOURCE_HIGHEST_ID
				};
			}
			return selectedResources;
		}

		return {
			selectAllInTeam: isOptimizeNewAndSaveExisting ? !!isResourceSelected : true,
			selectedIds: {
				[resource.id]: isOptimizeNewAndSaveExisting
					? { isChecked: !!isResourceSelected, disabled: !!isResourceSelected }
					: { isChecked: true, disabled: resource.id <= CUSTOM_RESOURCE_HIGHEST_ID }
			}
		};
	};

	return {
		createCheckboxDataByResources,
		createResourceCheckboxDataObject,
		isResourceSelectedOnPreviousOptimization
	};
};

export default useResourceCheckbox;
